import { DependencyList, useEffect } from 'react';

import {
  SocketApi,
  ICountResponse,
  INewMessagesCountResponse,
  IRealtimeMessageResponse,
} from '@api';

interface IMainSocketListenersParams {
  onConversationCount: (param: ICountResponse) => void;
  onNewMessagesCount: (params: INewMessagesCountResponse) => void;
}

export function useMainSocketListeners(
  params: IMainSocketListenersParams,
  deps?: DependencyList,
) {
  useEffect(() => {
    SocketApi.Chat.onConversationsCount(params.onConversationCount);
    SocketApi.Chat.onNewMessagesCount(params.onNewMessagesCount);

    return () => {
      SocketApi.Chat.removeAllEvents();
    };
  }, [deps]);
}

interface IMessagesSocketListenersParams {
  onReceive: (params: IRealtimeMessageResponse) => void;
}

export function useMessagesSocketListeners(
  params: IMessagesSocketListenersParams,
  deps?: DependencyList,
) {
  useEffect(() => {
    const remove = SocketApi.Chat.onReceiveMessage(params.onReceive);

    return () => remove();
  }, [deps]);
}
